import { Skeleton } from '@mui/material'

interface Props {
  text: string | JSX.Element
  children: JSX.Element
}

export function TextWithSkeleton({ text, children }: Props) {
  if (!text) return <Skeleton variant="text" />
  return children
}
